// src/ui/widgets/ThemeWrapper.jsx

import React, { useEffect } from 'react';

// ── ThemeWrapper ─────────────────────────────────────────────────────────────

export const ThemeWrapper = ({ children }) => {
  // ── Set meta viewport for mobile ─────────────────────────────────────────

  useEffect(() => {
    // Set viewport for proper mobile rendering
    let viewport = document.querySelector('meta[name=viewport]');
    if (!viewport) {
      viewport = document.createElement('meta');
      viewport.name = 'viewport';
      document.head.appendChild(viewport);
    }
    viewport.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover';

    // Set theme color
    let themeColor = document.querySelector('meta[name=theme-color]');
    if (!themeColor) {
      themeColor = document.createElement('meta');
      themeColor.name = 'theme-color';
      document.head.appendChild(themeColor);
    }
    themeColor.content = '#08090B';

    // Set status bar style via meta tags for mobile
    let statusBarStyle = document.querySelector('meta[name=apple-mobile-web-app-status-bar-style]');
    if (!statusBarStyle) {
      statusBarStyle = document.createElement('meta');
      statusBarStyle.name = 'apple-mobile-web-app-status-bar-style';
      document.head.appendChild(statusBarStyle);
    }
    statusBarStyle.content = 'black-translucent';

    // Set apple mobile web app capable
    let appleCapable = document.querySelector('meta[name=apple-mobile-web-app-capable]');
    if (!appleCapable) {
      appleCapable = document.createElement('meta');
      appleCapable.name = 'apple-mobile-web-app-capable';
      document.head.appendChild(appleCapable);
    }
    appleCapable.content = 'yes';

    // ── Apply body styles ──────────────────────────────────────────────────

    document.body.style.backgroundColor = '#08090B';
    document.body.style.color = '#FFFFFF';
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.fontFamily = 'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
    document.body.style.webkitFontSmoothing = 'antialiased';
    document.body.style.mozOsxFontSmoothing = 'grayscale';
    document.body.style.overflowX = 'hidden';
    document.body.style.minHeight = '100vh';
    document.body.style.minHeight = '100dvh';

    // ── Cleanup ─────────────────────────────────────────────────────────────

    return () => {
      // Reset body styles on unmount (optional)
      document.body.style.backgroundColor = '';
      document.body.style.color = '';
      document.body.style.margin = '';
      document.body.style.padding = '';
      document.body.style.fontFamily = '';
      document.body.style.webkitFontSmoothing = '';
      document.body.style.mozOsxFontSmoothing = '';
      document.body.style.overflowX = '';
      document.body.style.minHeight = '';
    };
  }, []);

  // ── Render children ──────────────────────────────────────────────────────

  return <>{children}</>;
};

export default ThemeWrapper;